import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectInventory } from 'app/pages/GenerateEmailFromTemplatesPage/selectors';

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Button from '@mui/material/Button';

const styleVehicleSelectionModal = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '1500px',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function VehicleSelectionModal({
  openVehicleSelectionModal,
  setOpenVehicleSelectionModal,
  selectionModel,
  setSelectionModel,
  handleRowSelection,
  setSelectedVehicles,
}) {
  const inventoryDetails = useSelector(selectInventory);
  const inventory = inventoryDetails.data?.body?.inventories || [];

  const handleCloseVehicleSelectionModal = () =>
    setOpenVehicleSelectionModal(false);

  const columns: GridColDef[] = [
    {
      field: 'year',
      headerName: 'Year',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'make',
      headerName: 'Make',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'model',
      headerName: 'Model',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'mileage',
      headerName: 'Mileage',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'price',
      headerName: 'Price',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'New_Auto_Class',
      headerName: 'New Auto Class',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'vin',
      headerName: 'Vin',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'inventory_type',
      headerName: 'Type',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'image_url',
      headerName: 'Image URL',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'MFG_CNT',
      headerName: 'MFG_CNT',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'MFG_MAKE',
      headerName: 'MFG_MAKE',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'MFG_POS',
      headerName: 'MFG_POS',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'MFG_TYPE',
      headerName: 'MFG_TYPE',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'F11',
      headerName: 'F11',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'F12',
      headerName: 'F12',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'F13',
      headerName: 'F13',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'description',
      headerName: 'description',
      width: 200,
      align: 'center',
      headerAlign: 'center',
    },
  ];

  return (
    <Modal
      open={inventoryDetails.loading ? false : openVehicleSelectionModal}
      onClose={handleCloseVehicleSelectionModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <>
        <Box sx={styleVehicleSelectionModal}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ textAlign: 'center' }}
          >
            Select Vehicles
          </Typography>

          <div style={{ height: '500px', marginTop: '30px' }}>
            <DataGrid
              rows={inventory}
              columns={columns}
              getRowId={row => row._id}
              pageSize={50}
              rowsPerPageOptions={[25, 50, 100]}
              checkboxSelection
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              onSelectionModelChange={newSelectionModel => {
                setSelectionModel(newSelectionModel);
                handleRowSelection(newSelectionModel);
              }}
              selectionModel={selectionModel}
            />
          </div>

          <div
            style={{
              display: 'flex',
              marginTop: '30px',
            }}
          >
            <Button
              variant="contained"
              color="secondary"
              onClick={e => {
                handleCloseVehicleSelectionModal();
                setSelectedVehicles([]);
                setSelectionModel([]);
              }}
              sx={{ marginLeft: 'auto', color: 'white' }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCloseVehicleSelectionModal}
              sx={{ marginLeft: '20px', color: 'white' }}
            >
              Select Vehicles
            </Button>
          </div>
        </Box>
      </>
    </Modal>
  );
}
